"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classcat_1 = require("classcat");
var theme = require("./theme.module.scss");
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
})(KeyCodes || (KeyCodes = {}));
var Editable = /** @class */ (function (_super) {
    tslib_1.__extends(Editable, _super);
    function Editable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onContainerClick = function (e) {
            _this.props.onClick && _this.props.onClick(e);
            if (!_this.state.editMode) {
                var anchorOffset_1 = window.getSelection().anchorOffset;
                _this.toggleEditMode(function () {
                    _this.inputRef.current.focus();
                    _this.inputRef.current.setSelectionRange(anchorOffset_1, anchorOffset_1);
                });
            }
        };
        _this.handleFinishEdit = function () {
            var _a = _this.props, value = _a.value, item = _a.item, onEdit = _a.onEdit;
            var newValue = _this.inputRef.current.value;
            _this.toggleEditMode();
            if (newValue === value) {
                return;
            }
            onEdit(newValue, item);
        };
        _this.onInputKeyDown = function (e) {
            switch (e.which) {
                case KeyCodes.Enter:
                    _this.handleFinishEdit();
                    break;
                case KeyCodes.Escape:
                    _this.handleCancelEdit();
                    break;
            }
        };
        _this.state = { editMode: false };
        _this.inputRef = React.createRef();
        return _this;
    }
    Editable.prototype.toggleEditMode = function (cb) {
        this.setState({ editMode: !this.state.editMode }, cb);
    };
    Editable.prototype.handleCancelEdit = function () {
        this.toggleEditMode();
    };
    Editable.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, truncate = _b.truncate, inputClassName = _b.inputClassName, value = _b.value, inputType = _b.inputType, onEdit = _b.onEdit, item = _b.item, others = tslib_1.__rest(_b, ["className", "truncate", "inputClassName", "value", "inputType", "onEdit", "item"]);
        var editMode = this.state.editMode;
        return (React.createElement("div", tslib_1.__assign({}, others, { onClick: this.onContainerClick, className: classcat_1.default([theme.editable, className, (_a = {},
                    _a[theme.truncate] = truncate,
                    _a)]) }), editMode ? (React.createElement("input", { "data-editable-input": true, ref: this.inputRef, type: inputType, defaultValue: value, onKeyDown: this.onInputKeyDown, onBlur: this.handleFinishEdit, className: inputClassName })) : value));
    };
    Editable.defaultProps = {
        inputType: "text",
        truncate: true
    };
    return Editable;
}(React.PureComponent));
exports.default = Editable;
